import { IdoRelationsForAnIdo } from 'src/models/ido';

import { Callback } from 'src/util/query/models/Callback';

import { SetIdoRelationsForAnIdoLoadingPayload, SetIdoRelationsForAnIdoPayload } from '../interfaces';

export class GetTheIdoRelationsForAnIdoQueryCallback extends Callback<IdoRelationsForAnIdo[]> {
	public constructor(
		private readonly idoRecordIdentifier: string,
		private readonly setIdoRelationsForAnIdo: (payload: SetIdoRelationsForAnIdoPayload) => void,
		private readonly setIdoRelationsForAnIdoLoading: (payload: SetIdoRelationsForAnIdoLoadingPayload) => void
	) {
		super();
	}

	failureCallbackFunction = (): void => {
		this.setIdoRelationsForAnIdoLoading({
			idoRecordIdentifier: this.idoRecordIdentifier,
			loading: false,
		});
	};

	successCallbackFunction = (successResponse: IdoRelationsForAnIdo[]): void => {
		this.setIdoRelationsForAnIdo({
			idoRecordIdentifier: this.idoRecordIdentifier,
			idoRelationsForAnIdo: successResponse,
		});
		this.setIdoRelationsForAnIdoLoading({
			idoRecordIdentifier: this.idoRecordIdentifier,
			loading: false,
		});
	};
}
